import { ICreditSend } from 'src/types/credit';
import { CreditFormData } from 'src/screens/General/screens/Credits/components/CreditForm';
import { changeToZeroMomentDate } from 'src/helpers/timeHelpers';

const groupCredit = (dataForm: Partial<CreditFormData>): Partial<ICreditSend> => {
    const { creditInvoices, applianceDate } = dataForm;
    const dataSend: Partial<ICreditSend> = {};

    if (applianceDate) {
        dataSend.applianceDate = changeToZeroMomentDate(applianceDate);
    }

    if (creditInvoices) {
        const arrInvoices: any = [];
        Object.keys(creditInvoices).forEach((k: any) => {
            const am = creditInvoices[k]['remainingAmount'];
            if (creditInvoices[k]['action']) {
                const itTo = { invoice: k, amount: parseFloat(`${am}`) };
                arrInvoices.unshift(itTo);
            }
        });

        dataSend.paymentInvoices = arrInvoices;
    }
    return dataSend;
};
export { groupCredit };
